module.exports = __webpack_public_path__ + "img/1080_22.2156df60.jpg";